import WordMarks from "./WordMarksTable";

export default WordMarks;
